import { describeFields, FieldWidget } from '../common/fields';
import { LessonSchema } from './schemas';

export const LESSON_FIELDS = describeFields(LessonSchema, {
  lessonTemplateCode: {},
  startDatetime: { widget: FieldWidget.DateTime },
  studentCount: {},
  absenteeCount: {},
  rollMarked: { widget: FieldWidget.Text },
  notes: {},
  homeworkMarked: {},
  location: {},
  roomId: { widget: FieldWidget.Select, displayField: 'roomLabel' },
  billingType: {},
  duration: {},
  enrolledStudents: {},
  makeUpCount: {},
  onlineCount: {},
  teacherId: { widget: FieldWidget.Autocomplete, displayField: 'teacherName' },
  separatelyBilled: { widget: FieldWidget.Text },
  streamId: {},
});
